// Step Types
import Basic from '../components/Steps/Basic';
import Price from '../components/Steps/Price';
import ProductPrice from '../components/Steps/ProductPrice';

// Step Components
import Accordion from '../components/Steps/General/Accordion';
import AccordionAdvanced from '../components/Steps/General/AccordionAdvanced';
import AutoSuggest from '../components/Steps/Input/AutoSuggest';
import Button from '../components/Steps/General/Button';
import Condition from '../components/Steps/General/Condition';
import ColumnLayout from '../components/Steps/General/ColumnLayout';
import ComponentGroup from '../components/Steps/General/ComponentGroup';
import Hero from '../components/Steps/General/Hero';
import InfoBox from '../components/Steps/General/InfoBox';
import ProductBox from '../components/Steps/General/ProductBox';
import ProductSelector from '../components/Steps/General/ProductSelector';
import InputGroup from '../components/Steps/Input/InputGroup';
import InputSelect from '../components/Steps/Input/Select';
import InputText from '../components/Steps/Input/Text';
import CprText from '../components/Steps/Input/CprText';
import TextArea from '../components/Steps/Input/TextArea';
import Slider from '../components/Steps/General/Slider';
import Carousel from '../components/Steps/General/Carousel';
import Space from '../components/Steps/General/Space';
import TextText from '../components/Steps/General/TextBlock';
import Ajax from '../components/Steps/General/Ajax';
import Link from '../components/Steps/General/Link';
import Coverage from '../components/Steps/General/Coverage';
import Title from '../components/Steps/General/Title';
import ProductSummary from '../components/Steps/General/ProductSummary';
import TextSimple from '../components/Global/Text';
import BackButton from '../components/Global/BackButton';
import Recommendation from '../components/Steps/General/Recommendation';
import RecommendationContact from '../components/Steps/General/RecommendationContact';
import ProductsOverview from '../components/Steps/General/ProductsOverview';
import GraphicLoader from '../components/Steps/General/GraphicLoader';
import TextLoader from '../components/Steps/General/TextLoader';
import ActionText from '../components/Steps/General/ActionText';
import TrustPilotWidget from '../components/Steps/General/Trustpilot';
import IdleAction from '../components/Steps/General/IdleAction';
import OptionalCoverages from '../components/Steps/General/OptionalCoverages';
import Label from '../components/Form/Label';
import Icon from '../components/Global/Icon';
import DatePicker from '../components/Steps/Input/DatePicker';
import SnackBar from '../components/Steps/General/SnackBar';
import RecommendationSlider from '../components/Steps/General/RecommendationSlider';

// Step Types
export const stepTypes = {
  Basic,
  Price,
  ProductPrice,
};

// Step Components
export const stepComponents = {
  // General
  'accordion': Accordion,
  'accordionAdvanced': AccordionAdvanced,
  'button': Button,
  'condition': Condition,
  'columnLayout': ColumnLayout,
  'componentGroup': ComponentGroup,
  'hero': Hero,
  'infoBox': InfoBox,
  'productBox': ProductBox,
  'productSelector': ProductSelector,
  'slider': Slider,
  'carousel': Carousel,
  'link': Link,
  'coverage': Coverage,
  'productSummary': ProductSummary,
  'recommendation': Recommendation,
  'productsOverview': ProductsOverview,
  'recommendationContact': RecommendationContact,
  'recommendationSlider': RecommendationSlider,
  'snackBar': SnackBar,
  'graphicLoader': GraphicLoader,
  'textLoader': TextLoader,
  'idleAction': IdleAction,
  'label': Label,
  'icon': Icon,
  // Group
  'checkbox': InputGroup,
  'checkboxButtons': InputGroup,
  'radio': InputGroup,
  'radioButtons': InputGroup,
  'select': InputSelect,
  'toggleSwitch': InputGroup,
  // Input
  'autoSuggest': AutoSuggest,
  'text': InputText,
  'email': InputText,
  'number': InputText,
  'password': InputText,
  'tel': InputText,
  'space': Space,
  'cprText': CprText,
  'textarea': TextArea,
  'datePicker': DatePicker,
  // Text
  'textBlock': TextText,
  'textHeader': TextText,
  'title': Title,
  'textSimple': TextSimple,
  'splashBanner': TextText,
  // Ajax
  'ajax': Ajax,
  'backButton': BackButton,
  'actionText': ActionText,
  'trustPilotWidget': TrustPilotWidget,
  'optionalCoverages': OptionalCoverages,
};


// WEBPACK FOOTER //
// ./src/constants/Steps.js